export default (...fns: any[]) => (data: any) =>
  fns.reduceRight((value, func) => {
    if (typeof func === 'function') {
      return func(value);
    }
    return value;
  }, data);
